import {createApiReadAction} from '../../common/utils/api';
import {isEmpty} from 'lodash';

export const initialState = {
	hasAccepted: true
};

export const CHECK_USER_ACCEPTED_PAANS_POLICY = 'paans/get/all';
export default function reducer(state = initialState, action) {
	state = isEmpty(state) ? initialState : state;
	switch (action.type) {
		case CHECK_USER_ACCEPTED_PAANS_POLICY: {
			return {
				...state,
				...action.response
			};
		}
		default: {
			return state;
		}
	}
}

export function checkUserAcceptedPaansPolicy(isAdmin, acceptUrl) {
	let queryString = isAdmin ? {isFromAdmin: true} : undefined;
	if (acceptUrl && queryString) {
		queryString.acceptUrl = acceptUrl;
	} else {
		queryString = {acceptUrl: acceptUrl};
	}
	return createApiReadAction(CHECK_USER_ACCEPTED_PAANS_POLICY, {paans: undefined}, queryString);
}
